import Bowser from "bowser";

export const isIOS = () => {
  const os = Bowser.getParser(navigator.userAgent).getOSName();
  return os === "iOS";
};

export const isMac = () => {
  const os = Bowser.getParser(navigator.userAgent).getOSName();
  return os === "macOS";
};

export const isAndroid = () => {
  const os = Bowser.getParser(navigator.userAgent).getOSName();
  return os === "Android";
};

export const isChromebook = () => /(CrOS)/i.test(navigator.userAgent);

export const isChrome = () => {
  const bowser = Bowser.getParser(navigator.userAgent);
  return bowser.isBrowser("Chrome");
};

export const isSafari = () => {
  const bowser = Bowser.getParser(navigator.userAgent);
  return bowser.isBrowser("Safari");
};

export const isTouchDevice = () => "ontouchstart" in document.documentElement;

export const deviceCheck = () => {
  if (isAndroid()) {
    return "android";
  }

  if (isMac()) {
    return "mac";
  }

  if (isIOS()) {
    return "ios";
  }

  if (isChromebook()) {
    return "chrome";
  }

  return "";
};
